import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

const LeadFormBar = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [destination, setDestination] = useState("");

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) {
      toast.error("Please fill in your name and phone number");
      return;
    }
    if (phone.trim().length < 7 || phone.trim().length > 15) {
      toast.error("Please enter a valid phone number");
      return;
    }
    setSubmitting(true);
    try {
      const { error } = await supabase.functions.invoke("send-lead-notification", {
        body: { name: name.trim(), phone: phone.trim(), email: email.trim(), destination: destination.trim() }
      });
      if (error) throw error;
      toast.success("Thank you! We'll get back to you shortly.");
      setName("");
      setPhone("");
      setEmail("");
      setDestination("");
    } catch (err) {
      console.error("Lead submit error:", err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-primary/10 border-b border-primary/20">
      















































    </div>);

};

export default LeadFormBar;